import React from 'react';
import moment from 'moment';
import Icon from '../../jo-components/ui/icon/icon';

function capitalizeFirstLetter(string) {
	if (!string || string.length === 0) {
		return "";
	}

	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// the Month/Year dropdowns above calendar
export const SelectMonthYear = ({ month, onMonthSelect, onYearSelect, years, callback }) => {
	return (
		<div className={"wz-date-picker__select-month-year"}>
			<div>
				<select
					tabIndex="-1"
					aria-hidden={true}
					className={"wz-date-picker__select-month"}
					value={month.month()}
					onChange={e => {
						onMonthSelect(month, e.target.value);
						callback();
					}}
				>
					{moment.months().map((label, value) => (
						<option tabIndex="-1" key={value} value={value}>
							{capitalizeFirstLetter(label)}
						</option>
					))}
				</select>
			</div>
			<div>
				<select
					tabIndex="-1"
					aria-hidden={true}
					className={"wz-date-picker__select-year"}
					value={month.year()}
					onChange={e => {
						onYearSelect(month, e.target.value);
						callback();
					}}
				>
					{years.map(year => (
						<option tabIndex="-1" key={year.value} value={year.value}>
							{year.label}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

// make the parent of a component selectable or not (tab, voiceover)
export function ParentSelectable({children, selectable = true, onBlur = null, className, day = null}) {
	const ref = React.useRef(null);
	React.useEffect(() => {
		if (ref?.current?.parentElement) {
			let isDisabled = false;
			if (day) {
				isDisabled = ref.current.parentElement.getAttribute('aria-disabled') === 'true';
				if (onBlur) {
					ref.current.parentElement.addEventListener('keydown', (e) => {if (e.key === "Escape") onBlur()});
					ref.current.parentElement.addEventListener('focusout', (e) => setTimeout(() => onBlur(e), 100));
				}
			}
			ref.current.parentElement.setAttribute('tabindex', selectable && !isDisabled ? '0' : '-1');
			ref.current.parentElement.setAttribute('aria-hidden', !(selectable && !isDisabled) );
		}
	}, [ref, onBlur, day])

	return (
		<span ref={ref} aria-hidden={true} tabIndex="-1" className={className}>{children}</span>
	)
}

// Arrows above calendar to change month (unfocusable)
export function NavArrow({direction}) {
	return (
		<ParentSelectable selectable={false}>
			<button tabIndex="-1" aria-hidden={true} className={`DayPickerNavigation_${direction}Button__horizontalDefault`}>
				<Icon name="arrow" />
			</button>
		</ParentSelectable>
	)
}

export function SelectableDay({ day, onBlur }) {
    return (
        <ParentSelectable day={day} selectable={true} onBlur={onBlur} className="CalendarDay-selectable">
			{day.format("D")}
		</ParentSelectable>
    );
}